export default __webpack_public_path__ + "static/branded-abt1-80b15dd3a123db08dd16d8be611a9d07.jpeg";